import compareModalConstants    from './compareModal.constants';
import compareModalInitialState from './compareModal.state';

function compareModalReducer(state = compareModalInitialState, action) {
  switch (action.type) {
    case compareModalConstants.SHOW_MODAL:
      state = {
        comparisonLabel: action.comparisonLabel || compareModalInitialState.comparisonLabel,
        door:            action.door || compareModalInitialState.door,
        open:            true,
      };
      break;

    case compareModalConstants.HIDE_MODAL:
      state = { ...compareModalInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default compareModalReducer;